import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  directLinkSectionMessageEmbed: {
    id: 'proforma-jira-issue-forms.ui.general.direct-link-section-message-embed',
    defaultMessage: 'Create issues using embedded forms by pasting this link on any Atlassian site. <a>Copy link</a>',
    description: 'Issue Forms Direct link message displayed when the form has loaded in ProForma Issue Forms General.'
  }
});